import { Component, type ReactNode } from "react";

export class InterfaceBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    return this.state.failed ? <main className="loading"><p role="alert">Não foi possível mostrar esta tela. Recarregue a página para tentar novamente.</p><button onClick={() => window.location.reload()}>Recarregar</button><a href="/">Voltar ao início</a></main> : this.props.children;
  }
}
